import { useTranslation } from 'react-i18next'

interface Props {
  message: string | undefined
}

const ValidationErrorMessage = ({ message }: Props) => {
  const { t } = useTranslation()
  
  return (
    <div style={{ position: 'relative', marginBottom: '1.5rem' }}>
      {message && (
        <p style={{ position: 'absolute', marginTop: '0.7rem' }} className="error-message">
          {t(message, { ns: 'shared', defaultValue: message })}
        </p>
      )}
    </div>
  )
}

export default ValidationErrorMessage
